<template>
  <div>
    <template v-if="section">
      <h3 class="text-2xl my-2">
        {{ lang.section.section }} {{ section.letter_code }}
      </h3>
      <div class="flex flex-wrap gap-4 mb-4">
        <a-badge
          :style="{
            background: section.specialization.color,
            color: section.specialization.text_color,
          }"
        >
          {{ section.specialization.title }}
        </a-badge>
        <a-badge class="bg-pink-400 text-white text-opacity-90">
          Hembras: {{ section.females_assigned }} / {{ section.females_limit }}
        </a-badge>
        <a-badge class="bg-blue-400 text-white text-opacity-90">
          Varones: {{ section.males_assigned }} / {{ section.males_limit }}
        </a-badge>
      </div>
    </template>

    <a-table
      bordered
      :columns="user.isAdmin ? columns : columnsCoord"
      :source="sectionTeachers ? sectionTeachers.courses : [] || courses || []"
      overflow
      :loading="loading"
    >
      <template #td(teacher)="{ item, index }">
        <template v-if="index === assigning">
          <div class="flex items-center">
            <a-loader class="mr-2" /> Asignando...
          </div>
        </template>
        <template v-else>
          {{
            loadingTeachers ? lang.section.loading_teachers : getTeacher(item)
          }}
        </template>
      </template>
      <template #td(actions)="{ item, index }">
        <div class="flex items-center">
          <a-dropdown v-if="!user.isCoordinator" trigger="click">
            <button
              :disabled="assigning === index"
              class="mr-2 px-4 py-2 rounded-lg focus:outline-none"
              @click="openActions"
            >
              Asignar profesor
            </button>
            <template #menu class="p-4">
              <!-- Selección múltiple de profesores -->
              <v-select
                multiple
                style="width: 300px;"
                v-model="selectedTeachers[index]"
                placeholder="Selecciona uno o más profesores"
                show-search
                :options="
                teachers.map(($0) => ({ label: $0.full_name, value: $0.id }))
                "
              >
              </v-select>

              <button
                class="mt-2 px-4 py-2 rounded-lg bg-blue-500 text-white"
                @click="assignTeacher(item, index)"
                :disabled="selectedTeachers.length === 0"
              >
                Asignar
              </button>
            </template>
          </a-dropdown>
          <a-dropdown>
            <template #menu>
              <a-dropdown-item
                :to="{
                  name: 'section_course_set_schedule',
                  params: { section_id: section.id, course_id: item.id },
                }"
                v-if="user.isAdmin"
              >
                {{ lang.section.table.actions.buttons.set_schedule }}
              </a-dropdown-item>
              <a-dropdown-item
                :to="{
                  name: 'section_course_create_final_delivery',
                  params: { section_id: section.id, course_id: item.id },
                }"
                v-if="item.teachers.length > 0 && user.isAdmin"
              >
                {{ lang.section.table.actions.buttons.create_final_delivery }}
              </a-dropdown-item>
              <!--              <a-droppdown-item>-->
              <!--                <p class="p-2">Sin acciones</p>-->
              <!--              </a-droppdown-item>-->
            </template>
          </a-dropdown>
        </div>
      </template>
    </a-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapState({
      section: (state) => state.sections.section,
      sectionTeachers: (state) => state.sections.sectionTeachers,
      teachers: (state) => state.teachers.all.filter(($0) => $0.enabled),
      loadingTeachers: (state) => state.teachers.loading,
      loading: ({ sections }) => sections.loading,
      user: (state) => state.session.user,
    }),
    ...mapGetters({
      lang: "lang",
      columns: "sections/detailColumns",
      columnsCoord: "sections/detailColumnsForCoord",
    }),
  },
  data: () => ({
    assigning: null,
    search: "",
    teach: [],
    filteredTeachers: [],
    selectedTeachers: [],
  }),
  watch: {
    search(e) {
      this.teach = this.teachers.filter(
        ($0) =>
          $0.first_name.toLowerCase().includes(e.toLowerCase()) ||
          $0.last_name.toLowerCase().includes(e.toLowerCase())
      );
    },
    sectionTeachers(val){
      if(val){
        this.selectedTeachers = this.sectionTeachers.courses.map(section => section.teachers.map(teacher => ({label: teacher.full_name, value: teacher.id})))
        
      }
    },
  },
  methods: {
    openActions() {
      this.teach = this.teachers;
    },
    assignTeacher(item, index) {
      const teacher_ids = this.selectedTeachers[index].map((teacher) => teacher.value);
      this.assign({
        ...this.$route.params,
        course_id: item.id,
        teacher_ids,
      }).then(() => {
        const { section_id } = this.$route.params;
        this.fetchSection(section_id);
        this.fetchSectionTeachers(section_id);
        // this.selectedTeachers = [];
      });
    },
    ...mapActions({
      toggleActive: "sections/toggleActive",
      fetchTeachers: "teachers/index",
      assign: "sections/assignTeacherToSectionCourse",
      fetchSection: "sections/fetch",
      fetchSectionTeachers: "sections/fetchWithTeachers",
    }),
    getTeacher(item) {
      const mappedTeachers = item.teachers.map(
        (el) => `${el.first_name} ${el.last_name}`
      );
      console.log("mappedTeachers ===> ", mappedTeachers);
      if (mappedTeachers.length > 0) {
        return mappedTeachers.join(" - ");
      } else {
        return "Esta seccion no tiene profesores asignados";
      }
    },
    hasTeacher(item) {
      return this.teachers.find((el) => item.pivot.teacher_id === el.id);
    },
  },
};
</script>
